module.exports = __webpack_public_path__ + "static/media/MyReport.9f78e3a0.scss";


//////////////////
// WEBPACK FOOTER
// ./src/components/reports/myreport/MyReport.scss
// module id = 1249
// module chunks = 0